module.exports = __webpack_public_path__ + "img/camion3.2a4cdbd0.jpg";